import InfoTooltip from 'Components/InfoTooltip'
import { Typography } from '@mui/material'
import { t } from 'ttag'

function MaximumTripsPerDayInfoTooltip() {
  return (
    <InfoTooltip
      title={
        <Typography variant="body2">
          {t`How many daily trips are included in the ticket. A transfer within the transfer time limit does not count as a trip.`}
        </Typography>
      }
    />
  )
}

export default MaximumTripsPerDayInfoTooltip
